<template>
  <section class="section--comp">
    <div class="container items-center">
      <img
        class="mb-base"
        src="../../../../src/assets/images/demo/integrations-key-features.png"
        width="100%"
      />
      <h3 class="section--h3">Key Features</h3>
      <p class="section--p">
        Technology solutions for talent management in educational domain and HR. Our technology is
distributed as a plug-n-play SaaS and also to develop further via APIs.
      </p>
      <vertical-card-three-level-icon :cardData="cardData" />
    </div>
  </section>
</template>

<script>
import VerticalCardThreeLevelIcon from '../../../components/gtbrdd/vertical-card-three-level/VerticalCardThreeLevelIcon.vue';
export default {
  components: { VerticalCardThreeLevelIcon },
  data () {
      return {
          cardData: [
              {
                  img: require('../../../../src/assets/images/icons/alex-cubes.svg'),
                  title: 'Our Technology',
                  description: "Data analytics to simplify life! We don't just implement technology with the reason that it's latest but we don't ignore advancement either. We are constantly researching of newer and needed methods of solving basic people problems. Implementing science for simplicity."
              },
              {
                  img: require('../../../../src/assets/images/icons/alex-cubes.svg'),
                  title: 'Our Vision',
                  description: "Build an intuitive portfolio building & personality assessments platform for students and professionals. Provide a simple yet effective tool (SAAS) for universities & companies to profile talent."
              },
              {
                  img: require('../../../../src/assets/images/icons/alex-cubes.svg'),
                  title: 'Your Access',
                  description: "Our technology is distributed as a service via APIs, giving you ready access to our development capabilities. Integrate it to enhance your applications and use the power of our AI and research. Activate yourself as a developer and reach us out for any support with integrations or requests."
              }
          ]
      }
  }
}
</script>

<style scoped></style>